export function useBradleyEnvironment() {
  const documentUpload = import.meta.env.VITE_BRADLEY_DOCUMENT_UPLOAD_ENABLED
  const dataAnalysis = import.meta.env.VITE_BRADLEY_DATA_ANALYSIS_ENABLED
  const projects = import.meta.env.VITE_BRADLEY_PROJECTS_ENABLED
  const newFileUpload = import.meta.env.VITE_BRADLEY_NEW_FILE_UPLOAD_ENABLED
  const projectsAiOutputs = import.meta.env.VITE_BRADLEY_PROJECTS_AI_OUTPUTS_ENABLED

  return {
    documentUploadEnabled: documentUpload !== 'false',
    dataAnalysisEnabled: dataAnalysis !== 'false',
    projectsEnabled: projects === 'true',
    newFileUploadEnabled: newFileUpload === 'true',
    projectsAiOutputsEnabled: projectsAiOutputs === 'true',
  }
}
